export enum HearingTestTypes {
    TONAL = "tonal",
    NOISE = "noise",
    WORDS = "words",
    NUMBERS = "numbers",
    MO_NOISE = "mo_noise"
}
